import { render, staticRenderFns } from "./MarketReports.vue?vue&type=template&id=4ae519f8&scoped=true&"
import script from "./MarketReports.vue?vue&type=script&lang=js&"
export * from "./MarketReports.vue?vue&type=script&lang=js&"
import style0 from "./MarketReports.vue?vue&type=style&index=0&id=4ae519f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae519f8",
  null
  
)

export default component.exports